import React, { Fragment, useEffect } from 'react';
import { ModalType, useFormikPetitionFilters } from '../../../../utils';
import { PetitionsFilter } from '../../types';
import { useEntryStates } from '../../../../share';
import { usePetitions, usePetitionsById } from '../../../../hooks';
import PetitionsView from '../Views/PetitionsView';
import PetitionsDetailContainer from './PetitionsDetailContainer';
import { authAtom } from '../../../../state';
import { useAtom } from 'jotai';

const PetitionsContainer: React.FC = () => {
  const { data: entryStates } = useEntryStates();
  //manage state modal
  const [modalState, setModalState] = React.useState<{
    type: ModalType;
    id?: string;
  }>({ type: null, id: undefined });

  const [authData] = useAtom(authAtom);
  const [filter, setFilter] = React.useState<PetitionsFilter>({
    requester_id: authData?.user.id
  });
  const {
    data: petitions,
    isPending: loadList,
    refetch,
  } = usePetitions(filter);

  const { data: petition, isPending: loadById } = usePetitionsById(
    modalState.id
  );
  const handleModalToggle = (type: ModalType, id?: string) => {
    setModalState((prev) => ({
      type: prev.type === type ? null : type,
      id: id,
    }));
  };

  const handlePagination = (page: number) => {
    setFilter({
      page: page.toString(),
    });
  };

  const handleFilter = async (values: Partial<PetitionsFilter>) => {
    setFilter({
      ...values,
      requester_id: authData?.user.id,
      created_at: values.created_at
        ? new Date(values.created_at).toISOString().split('T')[0]
        : '',
    });
  };

  const formik = useFormikPetitionFilters({ onSubmit: handleFilter });

  useEffect(() => {
    refetch();
  }, [filter, refetch]);

  return (
    <Fragment>
      <PetitionsDetailContainer
        isOpen={modalState.type === 'detail'}
        OnClose={() => handleModalToggle('detail')}
        data={petition}
        isLoading={loadById}
      />

      <PetitionsView
        isLoading={loadList}
        data={petitions}
        states={entryStates}
        formik={formik}
        onViewCreate={() => handleModalToggle('create')}
        onViewDetail={(id) => handleModalToggle('detail', id)}
        onPagination={handlePagination}
        onResetFilters={() => {
          handleFilter({});
          formik.resetForm();
        }}
      />
    </Fragment>
  );
};

export default PetitionsContainer;
